/**
 * Smart Resume Section Reordering Service
 * Simplified version for the integration
 */

// Define interfaces for job roles configuration
type Domain = {
  id: number;
  name: string;
  primaryKeywords: string[];
  additionalKeywords?: string[];
  optimalSectionOrder: string[];
  industryInsight: string;
};

type JobRolesConfig = {
  categories: { name: string; domains: Domain[] }[];
};

// Main function to reorder resume sections
// function reorderResumeSections(options: any): string[] {
//   // Return a default section order
//   return getDefaultSectionOrder();
// }
export function reorderResumeSections(options: {
  jobRole: string;
  yearsOfExperience: number;
  countryCode: string;
  industry?: string;
}): string[] {
  const { jobRole, yearsOfExperience, countryCode } = options;

  // Start with basics
  const sectionOrder: string[] = ["Contact Information"];

  // Entry-level (0-2 years): Education before experience
  if (yearsOfExperience <= 2) {
    sectionOrder.push(
      "Professional Summary",
      "Education",
      "Skills",
      "Work Experience",
      "Projects",
      "Certifications",
    );
  }
  // Mid-level (3-5 years): Traditional order
  else if (yearsOfExperience <= 5) {
    sectionOrder.push(
      "Professional Summary",
      "Work Experience",
      "Skills",
      "Education",
      "Certifications",
      "Projects",
    );
  }
  // Senior (6+ years): Experience-focused
  else {
    sectionOrder.push(
      "Professional Summary",
      "Work Experience",
      "Skills",
      "Leadership & Achievements",
      "Education",
      "Certifications",
    );
  }

  // Role-specific adjustments
  if (jobRole.toLowerCase().includes("academic") || jobRole.toLowerCase().includes("researcher")) {
    // Add publications after experience
    const expIndex = sectionOrder.indexOf("Work Experience");
    sectionOrder.splice(expIndex + 1, 0, "Publications");
  }

  // Country-specific adjustments
  if (["DE", "FR", "CH", "AT"].includes(countryCode)) {
    // German-speaking countries often want personal info early
    sectionOrder.splice(1, 0, "Personal Information");
  }

  // Always end with these (if relevant)
  sectionOrder.push(
    "Languages",
    "Volunteer Experience",

    "Publications",
    "Hobbies & Interests",
    "References",
  );

  return sectionOrder;
}
// Default section order
function getDefaultSectionOrder(): string[] {
  return [
    "Contact Information",
    "Professional Summary",
    "Work Experience",
    "Skills",
    "Education",
    "Certifications & Licenses",
    "Projects",
    "Languages",
  ];
}

// Knowledge base function
function getFromKnowledgeBase(knowledgeBaseFile: string, searchTerm: string): string {
  return `Professional guidance for ${searchTerm}:
- Highlight relevant skills and experience
- Use keywords from job descriptions
- Quantify achievements where possible`;
}

// Export the functions
export { getFromKnowledgeBase };
